import React from 'react';
import { connect } from 'react-redux';
import * as formsAction from "../../redux/actions/formsAction";
import Modal from 'react-modal';
import { toast } from 'react-toastify';
import Message from "../../helper/component/Message";
import ControlService from "../../helper/controlservice";
import exportToCSV from "../../helper/exportToCsv"
import Loading from '../../helper/component/Loading';
import CSVReader from "react-csv-reader";

const uuidv4 = require('uuid/v4');

class ImportUI extends React.PureComponent {
    constructor() {
        super();
        this.state = {
            stap: 0,
            file: '',
            error: '',
            isModelOpened: false,
            uploacomplete: false,
            actiononDups: 'ignorenew',
            sheettag: '',
            sheetOwner: '',
            isApiCalling: false,
        };
    }
    componentDidMount() {

    }
    handleFiles = (data, fileInfo) => {
        var header = [];
        debugger;
        var first = Array.isArray(data) && data.length > 0 ? data[0] : {};
        Object.keys(first).forEach(key => {
            header.push({ label: key.trim(), value: key.trim() });
        })
        this.setState({ file: fileInfo, body: data, header: header });

        // Check for the various File API support.
        // if (window.FileReader) {
        //     var files = e.target.files;
        //     // FileReader are supported.
        //     this.setState({ file: files[0] }, () => this.getAsText(files[0]))
        // }
    }
    UploadFile() {
        if (this.props.control.addresponsetomodel) {
            this.props.dataIsLoading(true);
            this.setState({ isModelOpened: false }, () => this.upload());
        } else {
            this.upload();
        }
    }
    upload() {
        const { control, formid } = this.props;

        const { header, body, actiononDups, sheettag, sheetOwner } = this.state;
        var json = [];
        for (let i = 0; i < body.length; i++) {
            let item = body[i];
            let obj = {};
            header.forEach((_header) => {
                if (_header.value) {
                    obj[_header.value] = item[_header.label];
                }
            });
            obj.id = uuidv4();
            // if (control.addresponsetomodel) {
            //     this.props.resetData(obj, obj.id + 'write');
            // }
            json.push(obj);
        }

        if (control.addresponsetomodel) {
            const data = this.props.data[formid] ? this.props.data[formid] : {};
            var _value = [];
            if (Array.isArray(data[control.importmodelname])) {
                _value = data[control.importmodelname].concat(json);
            }
            else {
                _value = json;
            }
            setTimeout(() => {

                json.forEach(obj => {
                    this.props.resetData(obj, obj.id + 'write');
                });
                this.props.update(control.importmodelname, _value, formid);
                this.setState({ uploacomplete: true });
                this.props.dataIsLoading(false);
            }, 500)
        }
        else {
            this.setState({
                isApiCalling: true
            });
            let _control = ControlService().extractControl(control, 'import');
            var param = {};
            _control.ApiParam = control.importApiParam;
            if (Array.isArray(_control.ApiParam)) {
                _control.ApiParam.forEach(item => {
                    param[item.key] = item.value;
                });
            }
            param["validatecols"] = control.validatecols ? control.validatecols : [];
            param["mandatoryfield"] = control.mandatoryfield ? control.mandatoryfield : [];
            param["actiononDups"] = actiononDups;
            param["sheettag"] = sheettag;
            param["sheetOwner"] = sheetOwner;
            param["filename"] = this.state.file ? this.state.file.name : control.label;
            ControlService().ServiceRequest(control.importapiurl, param, _control, this.props.token, json, null, null, null, this.props)
                .then(res => {

                    var notification_import = this.props.notification_import;
                    if (Array.isArray(notification_import)) {
                        notification_import.push(res);
                    }
                    else {
                        notification_import = [];
                        notification_import.push(res);
                    }
                    this.props.setNotification(notification_import);
                    this.setState({
                        isApiCalling: false, stap: 4, uploacomplete: true
                    }, () => this.forceUpdate());
                    toast.success(<Message message={"Data processing started."} type="success" />);
                })
                .catch(err => {
                    this.setState({
                        isApiCalling: false
                    });
                    toast.success(<Message message={"Data processing started."} type="success" />);
                    // toast.error(<Message message={err.message} type="error" />)
                    console.log(err.message);
                });
        }
    }

    getAsText(fileToRead) {
        var reader = new FileReader();
        // Read file into memory as UTF-8      
        reader.readAsText(fileToRead);
        // Handle errors load
        reader.onload = this.fileReadingFinished.bind(this);
        reader.onerror = this.errorHandler;
    }

    processData(csv) {
        var allTextLines = csv.split(/\r\n|\n/);

        if (Array.isArray(allTextLines)) {
            var json = [];
            var header = allTextLines.length > 0 ? allTextLines[0].split(",") : {};
            var body = allTextLines.length > 1 ? allTextLines.slice(1, allTextLines.length) : [];
            var _header = [];
            header.forEach(item => {
                _header.push({ label: item.trim(), value: item.trim() });
            })

            for (let i = 0; i < body.length; i++) {
                let item = body[i].split(",");
                let obj = {};
                _header.forEach((_head, j) => {
                    if (_head.value) {
                        obj[_head.value] = item[j] ? item[j].replace(/"/gi, '').trim() : "";
                    }
                })
                obj.id = uuidv4();
                // if (control.addresponsetomodel) {
                //     this.props.resetData(obj, obj.id + 'write');
                // }
                json.push(obj);
            }
            this.setState({ header: _header, body: json });
        } else {
            this.setState({ error: "No data available" });
        }
    }

    fileReadingFinished(event) {
        var csv = event.target.result;
        this.processData(csv);
    }

    errorHandler(event) {
        if (event.target.error.name === "NotReadableError") {
            // alert("");
            this.setState({ error: "Cannot read file!" })
        }
    }
    updateMapping(value, index, type) {
        var { header } = this.state;
        if (type == 'unique') {
            header[index].isunique = value;
        } else {
            header[index].value = value ? value.trim() : '';
        }
        this.setState({ header: header });
    }
    downloadTemplate(control) {
        var exportColumns = [];
        control.templatefields.forEach(item => {
            var arr = {};
            arr.prop = item;
            arr.name = item;

            exportColumns.push(arr);
        })
        if (control.fetchtemplatedata) {
            this.setState({
                isApiCalling: true
            });
            var param = {};
            control.apiparam.forEach(item => {
                param[item.key] = item.value;
            });
            ControlService().ServiceRequest(control.apiurl, param, control, this.props.token, null, null, null, null, this.props)
                .then(res => {

                    this.setState({
                        isApiCalling: false
                    });
                    var result = [];
                    if (control.responsefield) {
                        result = res && res[control.responsefield] ? res[control.responsefield] : [];
                    } else {
                        result = res;

                    }
                    exportToCSV().generatecsvReport(exportColumns, result, "Template");
                })
                .catch(err => {
                    this.setState({
                        isApiCalling: false
                    });
                    toast.error(<Message message="Fetching data failed!" type="error" />)
                    console.log(err.message);
                });
        } else {
            exportToCSV().generatecsvReport(exportColumns, [], "Template");
        }
    }
    renderSteps(isClient) {
        return (
            <ul className={"steps-indicator steps-5"} role="tablist">
                <li className={(this.state.stap > 0 ? 'done' : '') + ' ' + (this.state.stap == 0 ? 'current' : '')}>
                    <button className='btn-no' onClick={(e) => {e.preventDefault();this.setState({ stap: 0 })}} step-symbol='&#xf093;'>Choose a file to upload</button>
                </li>
                <li className={(this.state.stap > 1 ? 'done' : '') + ' ' + (this.state.stap == 1 ? 'current' : '')}>
                    <button className='btn-no' onClick={(e) => {e.preventDefault();this.setState({ stap: 1 })}} step-symbol='&#xf046;'>Map Columns with Fields</button>
                </li>
                {!isClient &&
                    <li className={(this.state.stap > 2 ? 'done' : '') + ' ' + (this.state.stap == 2 ? 'current' : '')}>
                        <button className='btn-no' onClick={(e) => {e.preventDefault();this.setState({ stap: 2 })}} step-symbol='&#xf0b0;'>Rules and Options</button>
                    </li>
                }
                <li className={(this.state.stap > 3 ? 'done' : '') + ' ' + (this.state.stap == 3 ? 'current' : '')}>
                    <button className='btn-no' onClick={(e) => {e.preventDefault();this.setState({ stap: 3 })}} step-symbol='&#xf019;'>Preview and Import</button>
                </li>
                <li className={(this.state.stap > 4 ? 'done' : '') + ' ' + (this.state.stap == 4 ? 'current' : '')}>
                    <button className='btn-no' onClick={(e) => {e.preventDefault();this.setState({ stap: 4 })}} step-symbol='&#xf087;'>Thank You</button>
                </li>
            </ul>
        )
    }
    renderStepZero(isClient) {
        const { control } = this.props;
        return (
            <div className='import-wizard-step-content'>
                <div className="card text-center mt-3">
                    <div className="card-header">
                        {isClient ?
                            <div className="h5 mb-0">Choose a file to upload ({(control.templatefields && control.templatefields.length) > 0 &&
                                <i className="btn pointer p-0 "
                                    onClick={() => { this.downloadTemplate(control) }}>
                                    {control.templatename ? control.templatename : "Download Template"}
                                </i>
                            })</div>
                            :
                            <>
                                {(control.templatefields && control.templatefields.length) > 0 &&
                                    <button type="button"
                                        className={"btn btn-link"}
                                        onClick={() => { this.downloadTemplate(control) }}>
                                        {control.templatename ? control.templatename : "Download Template"}
                                    </button>
                                }
                                <div className="h5 mb-0">Choose a file to upload</div>
                            </>
                        }
                    </div>
                    <div className="card-body">
                        {!this.state.file &&
                            <div className="text-center file-upload">
                                <div className="file-btn pointer btn btn-dark">
                                    Select a file
                                    {/* <input className="pointer" type="file"
                                                        onChange={this.handleFiles} /> */}
                                    <CSVReader
                                        cssClass="pointer"
                                        label=""
                                        onFileLoaded={this.handleFiles}
                                        parserOptions={{
                                            header: true,
                                            dynamicTyping: true,
                                            skipEmptyLines: true,
                                            transformHeader: header => header.toLowerCase().replace(/\W/g, isClient ? "" : "_")
                                        }}
                                    />
                                </div>
                            </div>
                        }
                        {this.state.file &&
                            <div>
                                <label className="d-block">{this.state.file.name}</label>
                                <button className="btn btn-outline-secondary" onClick={() => this.setState({ file: '' })}>Remove File</button>
                            </div>
                        }
                    </div>
                    <div className="card-footer d-flex justify-content-end">
                        <button type="button" className="btn btn-sm btn-outline-dark ml-auto" onClick={() => this.setState({ stap: 1 })}>Preview & Import<i className="fa fa-arrow-right pl-2"></i></button>
                    </div>
                </div>
            </div>
        )
    }
    renderStepOne(isClient, mappingfield) {
        const { control } = this.props;
        return (
            <div className='import-wizard-step-content'>
                <div className="card mt-3">
                    <div className="card-header text-center">
                        <div className="h5 mb-0">Map Columns with Fields</div>
                    </div>
                    <div className="card-body">
                        {!isClient && <div className="mb-3" ngIf="control.mandatoryfield && control.mandatoryfield.length>0">
                            <label>Mandatory <strong>Map Fields</strong></label><span className="text-danger"> *</span>
                            <ul>
                                {control.mandatoryfield && control.mandatoryfield.map(column => {
                                    return (
                                        <li>
                                            <span>{column}</span>
                                        </li>
                                    )
                                })}
                            </ul>
                        </div>}
                        <div className="row pb-2">
                            <div className="col"><strong>File Columns</strong></div>
                            <div className="col"><strong>Map Fields</strong></div>
                            {!isClient && <div className="col-2 text-right"><strong>Duplicate Check</strong></div>}
                        </div>
                        <React.Fragment>
                            {
                                this.state.header && this.state.header.map((field, i) => {
                                    return (
                                        <div className="row pb-2">
                                            <div className="col"><input aria-label={field.label} type="text" className="form-control" value={field.label} disabled /></div>
                                            <div className="col">
                                                <select onChange={(e) => this.updateMapping(e.target.value, i)} className="form-control">
                                                    <option selected value={''}>Select</option>
                                                    {
                                                        mappingfield.length > 0 ?
                                                            mappingfield.map(item => {
                                                                if (field.value == item.value && item.value) {
                                                                    return (<option selected value={item.value}>{item.label}</option>)
                                                                } else if (item.value) {
                                                                    return (<option value={item.value}>{item.label}</option>)
                                                                }
                                                            })
                                                            :
                                                            this.state.header.map(item => {
                                                                if (field.value == item.value && item.value) {
                                                                    return (<option selected value={item.value}>{item.label}</option>)
                                                                } else if (item.value) {
                                                                    return (<option value={item.value}>{item.label}</option>)
                                                                }
                                                            })
                                                    }
                                                </select>
                                            </div>
                                            {!isClient && <div className="col-2">
                                                <div className="form-group">
                                                    <label className="switch">
                                                        <input type="checkbox"
                                                            aria-label={field.isunique}
                                                            onChange={(e) => this.updateMapping(e.target.checked, i, "unique")}
                                                            checked={field.isunique}
                                                            value={field.isunique}
                                                        />
                                                        <i className="switch-icon" data-swchon-text="ON" data-swchoff-text="OFF"></i>
                                                    </label>
                                                </div>
                                            </div>}
                                        </div>
                                    )
                                })
                            }
                        </React.Fragment>
                    </div>
                    <div className="card-footer d-flex justify-content-end">
                        <button type="button" className="btn btn-sm btn-outline-dark" onClick={() => this.setState({ stap: 0 })}><i className="fa fa-arrow-left pr-2"></i>Choose a file to upload</button>
                        {isClient ?
                            <button type="button" className="btn btn-sm btn-outline-dark ml-auto" onClick={() => this.setState({ stap: 3 })}>Preview & Import<i className="fa fa-arrow-right pl-2"></i></button>
                            :
                            <button type="button" className="btn btn-sm btn-outline-dark ml-auto" onClick={() => this.setState({ stap: 2 })}>Rules and Options<i className="fa fa-arrow-right pl-2"></i></button>
                        }
                    </div>
                </div>
            </div>
        )
    }
    renderStepThree(isClient) {
        return (
            <div className='import-wizard-step-content'>
                <div className="card mt-3">
                    <div className="card-header text-center">
                        <div className="h5 mb-0">Preview and Import</div>
                    </div>
                    <div className="card-body">
                        <div ngIf="duplicateChecks.length>0">
                            <p>Unique Columns for Duplicate checks :</p>
                            <ul className="list-group">
                                {/* <li className="list-group-item" ngFor="let column of duplicateChecks">
<span ngIf="column.isunique">column.colName</span>
</li> */}
                            </ul>
                        </div>
                        <div className="table-responsive">
                            <table className="table table-sm table-hover">
                                <thead className="thead-default">
                                    <tr>
                                        {
                                            this.state.header && this.state.header.map(item => {
                                                if (item.value) {
                                                    return (
                                                        <th>{item.value}</th>
                                                    )
                                                }
                                            })
                                        }
                                    </tr>
                                </thead>
                                <tbody>
                                    {
                                        this.state.body.map(item => {
                                            return (
                                                <tr>
                                                    {
                                                        this.state.header.map(_item => {
                                                            if (_item.value) {
                                                                return (
                                                                    <td>{item[_item.label] ? item[_item.label].toString() : item[_item.label]}</td>
                                                                )
                                                            }
                                                        })
                                                    }
                                                </tr>
                                            )
                                        })
                                    }
                                </tbody>
                            </table>
                        </div>
                    </div>
                    <div className="card-footer d-flex justify-content-end">
                        {isClient ?
                            <button type="button" className="btn btn-sm btn-outline-dark" onClick={() => this.setState({ stap: 1 })}><i className="fa fa-arrow-left pr-2"></i>Select Fields</button>
                            :
                            <button type="button" className="btn btn-sm btn-outline-dark" onClick={() => this.setState({ stap: 2 })}><i className="fa fa-arrow-left pr-2"></i>Rules and Options</button>
                        }
                        <button type="button" className="btn btn-sm btn-dark ml-auto" onClick={() => this.UploadFile()}>Upload</button>
                        {this.state.uploacomplete && <button type="button" className="btn btn-sm btn-outline-dark ml-auto" onClick={() => this.setState({ stap: 4 })}>Complete<i className="fa fa-arrow-right pl-2"></i></button>}
                    </div>
                </div>
            </div>
        )
    }
    renderStepFour() {
        return (
            <div className='import-wizard-step-content'>
                <div className="card mt-3 text-center">
                    <div className="card-header">
                        <div className="h5 mb-0">Thank You</div>
                    </div>
                    <div className="card-body">
                        <p className="mb-0">Your Import has been configured, you will get notification when import complete.</p>
                    </div>
                    <div className="card-footer d-flex justify-content-end">
                        <button type="button" className="btn btn-sm btn-outline-dark ml-auto" onClick={() => this.setState({ stap: 0, header: [], body: [], file: null, uploacomplete: false, isModelOpened: false })}>Close</button>
                    </div>
                </div>
            </div>
        )
    }
    renderImportClient(control) {
        var mappingfield = [];
        control.mappingfield && control.mappingfield.forEach(item => {
            mappingfield.push({ label: item, value: item });
        });
        return (
            <div className="modal-body" >
                <div className="import-wizard">
                    {this.renderSteps(true)}
                    <div className='import-wizard-steps-content'>
                        {this.state.stap == 0 ?
                            this.renderStepZero(true)
                            : this.state.stap == 1 ?
                                this.renderStepOne(true, mappingfield)
                                : this.state.stap == 3 ?
                                    this.renderStepThree(true)
                                    : this.state.stap == 4 ?
                                        this.renderStepFour()
                                        : null
                        }
                    </div>
                </div>

            </div>
        )
    }
    renderImport(control) {
        var mappingfield = [];
        control.mappingfield && control.mappingfield.forEach(item => {
            mappingfield.push({ label: item, value: item });
        });
        return (
            <div className="modal-body" >
                <div className="import-wizard">
                    {this.renderSteps(false)}
                    <div className='import-wizard-steps-content'>
                        {this.state.stap == 0 ?
                            this.renderStepZero(false)
                            : this.state.stap == 1 ?
                                this.renderStepOne(false, mappingfield)
                                : this.state.stap == 2 ?
                                    <div className='import-wizard-step-content'>
                                        <div className="card mt-3">
                                            <div className="card-header text-center">
                                                <div className="h5 mb-0">Rules and Options</div>
                                            </div>
                                            <div className="card-body">
                                                <div className="form-group">
                                                    <label className="required" htmlFor="docowner">Owner for records, if not mentioned in sheet</label>
                                                    <input type="text" aria-label="Owner for records, if not mentioned in sheet" id="docowner" style={{ "min-width": "115px" }} className="form-control" value={this.state.sheetOwner} onChange={(e) => this.setState({ sheetOwner: e.target.value })} />
                                                </div>
                                                <div className="form-group">
                                                    <label className="required" htmlFor="doctag">Tag newly imported contacts with</label>
                                                    <input aria-label="Tag newly imported contacts with" type="text" id="doctag" style={{ "min-width": "115px" }} className="form-control" value={this.state.sheettag} onChange={(e) => this.setState({ sheettag: e.target.value })} />
                                                </div>
                                                <div className="">
                                                    <label>What would you like to do with duplicate contacts?</label>
                                                    <div className="c-control c-radio">
                                                        <label>
                                                            <input aria-label="Ignore the new entry and keep the existing." className="c-control-input" name="filterAction" type="radio" checked={this.state.actiononDups === 'ignorenew'} onClick={() => this.setState({ actiononDups: 'ignorenew' })} value="'ignorenew'" />
                                                            <i className="c-control-indicator fa fa-circle-o"></i>
                                                            <span className="c-control-description">
                                                                Ignore the new entry and keep the existing.
                                                            </span>
                                                        </label>
                                                    </div>
                                                    <div className="c-control c-radio">
                                                        <label>
                                                            <input aria-label="Update existing with new one." className="c-control-input" name="filterAction" type="radio" checked={this.state.actiononDups === 'update'} onClick={() => this.setState({ actiononDups: 'updatev' })} value="'update'" />
                                                            <i className="c-control-indicator fa fa-circle-o"></i>
                                                            <span className="c-control-description">
                                                                Update existing with new one.
                                                            </span>
                                                        </label>
                                                    </div>
                                                    <div className="c-control c-radio">
                                                        <label>
                                                            <input aria-label="Create new entry and leave previous entry as it is." className="c-control-input" name="filterAction" type="radio" checked={this.state.actiononDups === 'addnew'} onClick={() => this.setState({ actiononDups: 'addnew' })} value="'addnew'" />
                                                            <i className="c-control-indicator fa fa-circle-o"></i>
                                                            <span className="c-control-description">
                                                                Create new entry and leave previous entry as it is.
                                                            </span>
                                                        </label>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="card-footer d-flex justify-content-end">
                                                <button type="button" className="btn btn-sm btn-outline-dark" onClick={() => this.setState({ stap: 1 })}><i className="fa fa-arrow-left pr-2"></i>Select Fields</button>
                                                <button type="button" className="btn btn-sm btn-outline-dark ml-auto" onClick={() => this.setState({ stap: 3 })}>Preview & Import<i className="fa fa-arrow-right pl-2"></i></button>
                                            </div>
                                        </div>
                                    </div>
                                    : this.state.stap == 3 ?
                                        this.renderStepThree(false)
                                        : this.state.stap == 4 ?
                                            this.renderStepFour()
                                            : null
                        }
                    </div>
                </div>

            </div>
        )
    }
    render() {
        const { control } = this.props;
        return (
            <React.Fragment>
                {control.openinpopup != false ?
                    <React.Fragment>
                        <button data-tip data-for={control.id}
                            onClick={() => { this.setState({ uploacomplete: false, isModelOpened: true, header: [], body: [], file: null, stap: 0 }) }} className={' btn ' + control.customClass + ' btn-' + control.buttontype + ' btn-' + control.size}>
                            {control.WebIcon &&
                                <i className={control.WebIcon + (control.label ? ' mr-2' : '')}></i>
                            }
                            {control.label}
                        </button>
                        {/* {control.templatefields.length > 0 &&
                            <button type="button"
                                className={"btn btn-link"}
                                onClick={(e) => { this.downloadTemplate(control) }}>
                                {control.templatename ? control.templatename : "Download Template"}
                            </button>
                        } */}
                        <Modal
                            isOpen={this.state.isModelOpened}
                            // onAfterOpen={() => this.afterOpenModal()}
                            // onRequestClose={() => this.openmodel()}
                            style={{
                                content: {
                                    top: '5%',
                                    left: '5%',
                                    right: '5%',
                                    bottom: '5%'
                                }
                            }}
                            overlayClassName='cameo'
                            shouldCloseOnOverlayClick={false}
                        >
                            <div className="modal-header d-flex align-items-center">
                                <div className="h4 mb-0">{this.state.file && this.state.file.name}</div>
                                <i className="fa fa-times fa-lg ml-auto" onClick={(() => this.setState({ uploacomplete: false, isModelOpened: false }))}></i>
                            </div>
                            <Loading token={this.props.token} enable={this.state.isApiCalling} class={this.state.isApiCalling ? "fixloader" : 'ishide'} />
                            {control.addresponsetomodel ? this.renderImportClient(control) : this.renderImport(control)}
                        </Modal>
                    </React.Fragment>
                    : control.addresponsetomodel ? this.renderImportClient(control) : this.renderImport(control)
                }
            </React.Fragment>
        );
    }
}
const mapStateToProps = state => ({
    data: state.formDataReducer,
    filterdata: state.formDataReducer.filterdata,
    editformdata: state.formDataReducer.editformdata,
    hasErrored: state.formDataReducer.hasErrored,
    isLoading: state.formDataReducer.isLoading,
    token: state.formLoginReducer.token,
    notification_import: state.formDataReducer.notification_import,
});
function bindAction(dispatch) {
    return {
        update: (key, value, storekey) => dispatch(formsAction.updateData(key, value, storekey)),
        resetData: (data, storekey) => dispatch(formsAction.resetFormData(data, storekey)),
        setNotification: (data, storekey) => dispatch(formsAction.setImportNotification(data, storekey)),
        dataIsLoading: (bool) => dispatch(formsAction.dataIsLoading(bool)),
    };
}
export default connect(mapStateToProps, bindAction)(ImportUI);